import { render, staticRenderFns } from "./ToS.vue?vue&type=template&id=9d87c2de&scoped=true&"
var script = {}
import style0 from "./ToS.vue?vue&type=style&index=0&id=9d87c2de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d87c2de",
  null
  
)

export default component.exports